import { Button } from "@mui/material"
import { SingleServiceCenterDto, postServiceCenterContact } from "api"
import { trackPopUpClicks, trackSuccessLead } from "common/analytics"
import FormikForm from "common/bit/form/FormikForm"
import PrivacyPolicyCaption from "common/PrivacyPolicyCaption"
import FormInput from "reusable/formsComp/FormInput"
import styled from "styled-components"
import { FormStatus } from "../popups/ContentUsPopup"
import { initialFormState, schema } from "./ContentUsSchema"

const StyledFormDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  width: 100%;
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-left: 20px;
    padding-right: 20px;
  }
`
const StyledButton = styled(Button)`
  margin: 20px 0px;
`

const StyledCol = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
  .MuiOutlinedInput-multiline {
    padding: 15px 14px;
  }
`
const StyledRowCol = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: auto;
  gap: 2px;
  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: row;
    column-gap: 16px;
  }
`
const StyledWrap = styled.div`
  width: 100%;
  max-width: 320px;
`
const StyledFormInput = styled(FormInput)`
  textarea {
    height: 94px !important;
  }
`
const StyledPhoneInput = styled(FormInput)`
  .MuiFormHelperText-root {
    text-align: right;
  }
`

type Props = {
  centerData: SingleServiceCenterDto
  setFormStatus: any
}

const ContentUsForm = ({ centerData, setFormStatus }: Props) => {
  return (
    <FormikForm
      validationSchema={schema}
      initialValues={initialFormState}
      onSubmit={async (values) => {
        try {
          const { data } = await postServiceCenterContact({
            name: values.fullName,
            mobilePhone: values.phoneNumber,
            serviceCenterId: centerData.id,
            applicationType: "Contact",
            rishui: values.licenseNumber,
            email: centerData.email,
            customerEmail: values.email,
            content: values.message ?? "",
            treatmentDate: "",
            treatmentTime: "",
            treatmentType: "Default",
          })
          if (data.body) {
            setFormStatus(FormStatus.Success)
            trackSuccessLead("יצירת קשר", "service_center_lead_success")
          } else {
            setFormStatus(FormStatus.Error)
          }
        } catch (error) {
          console.error(error)
          setFormStatus(FormStatus.Error)
        }
      }}
      render={(formik) => (
        <StyledFormDiv>
          <StyledRowCol>
            <StyledCol>
              <FormInput
                name="fullName"
                label="שם מלא"
                required
                onFocusCapture={() => trackPopUpClicks("יצירת קשר", "fullName")}
              />
              <StyledPhoneInput
                name="phoneNumber"
                type="tel"
                label="טלפון נייד"
                required
                helperText="יש להזין טלפון זמין ליצירת קשר ואישור מועד ההגעה"
                onFocusCapture={() =>
                  trackPopUpClicks("יצירת קשר", "phoneNumber")
                }
              />
              <FormInput
                name="email"
                label="כתובת מייל"
                required
                onFocusCapture={() => trackPopUpClicks("יצירת קשר", "email")}
                type="email"
              />
            </StyledCol>
            <StyledCol>
              <FormInput
                name="licenseNumber"
                label="מספר לוחית רישוי"
                required
                onFocusCapture={() =>
                  trackPopUpClicks("יצירת קשר", "licenseNumber")
                }
              />
              <StyledFormInput
                name="message"
                label="?איך נוכל לעזור"
                multiline
                minRows={5}
                onFocusCapture={() => trackPopUpClicks("יצירת קשר", "message")}
              />
            </StyledCol>
          </StyledRowCol>
          <PrivacyPolicyCaption />
          <StyledWrap>
            <StyledButton
              disabled={formik.isSubmitting}
              fullWidth
              variant="text"
              type={"submit"}
            >
              שליחה
            </StyledButton>
          </StyledWrap>
        </StyledFormDiv>
      )}
    />
  )
}

export default ContentUsForm
